import { render, staticRenderFns } from "./NoScopes.vue?vue&type=template&id=268a8235&"
import script from "./NoScopes.vue?vue&type=script&lang=js&"
export * from "./NoScopes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports